import { render, staticRenderFns } from "./ListMetalOff.vue?vue&type=template&id=b92800ac"
import script from "./ListMetalOff.vue?vue&type=script&lang=js"
export * from "./ListMetalOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports